// Timezone data organized by GMT offset
export const timezonesByGMT = [
  {
    gmt: 'GMT-12',
    locations: ['Baker Island']
  },
  {
    gmt: 'GMT-11',
    locations: ['American Samoa', 'Midway Islands']
  },
  {
    gmt: 'GMT-10',
    locations: ['Hawaii', 'Honolulu']
  },
  {
    gmt: 'GMT-9',
    locations: ['Alaska', 'Anchorage']
  },
  {
    gmt: 'GMT-8',
    locations: ['Los Angeles', 'San Francisco', 'Seattle', 'Las Vegas', 'Vancouver']
  },
  {
    gmt: 'GMT-7',
    locations: ['Denver', 'Phoenix', 'Calgary']
  },
  {
    gmt: 'GMT-6',
    locations: ['Chicago', 'Mexico City', 'Dallas', 'Houston']
  },
  {
    gmt: 'GMT-5',
    locations: ['New York', 'Toronto', 'Miami', 'Boston', 'Atlanta', 'Lima']
  },
  {
    gmt: 'GMT-4',
    locations: ['Santiago', 'Caracas', 'Halifax']
  },
  {
    gmt: 'GMT-3',
    locations: ['Buenos Aires', 'São Paulo', 'Rio de Janeiro', 'Montevideo']
  },
  {
    gmt: 'GMT-2',
    locations: ['South Georgia']
  },
  {
    gmt: 'GMT-1',
    locations: ['Azores', 'Cape Verde']
  },
  {
    gmt: 'GMT+0',
    locations: ['London', 'Lisbon', 'Dublin', 'Casablanca', 'Dakar', 'Reykjavik']
  },
  {
    gmt: 'GMT+1',
    locations: ['Paris', 'Berlin', 'Rome', 'Madrid', 'Amsterdam', 'Brussels', 'Vienna', 'Prague', 'Lagos', 'Algiers', 'Tunis']
  },
  {
    gmt: 'GMT+2',
    locations: ['Cairo', 'Athens', 'Istanbul', 'Jerusalem', 'Johannesburg', 'Helsinki', 'Bucharest', 'Beirut', 'Amman']
  },
  {
    gmt: 'GMT+3',
    locations: ['Riyadh', 'Kuwait City', 'Doha', 'Manama', 'Baghdad', 'Moscow', 'Nairobi', 'Addis Ababa']
  },
  {
    gmt: 'GMT+4',
    locations: ['Dubai', 'Abu Dhabi', 'Muscat', 'Baku', 'Tbilisi', 'Yerevan']
  },
  {
    gmt: 'GMT+5',
    locations: ['Karachi', 'Islamabad', 'Tashkent']
  },
  {
    gmt: 'GMT+5:30',
    locations: ['Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Kolkata', 'Colombo']
  },
  {
    gmt: 'GMT+6',
    locations: ['Dhaka', 'Almaty']
  },
  {
    gmt: 'GMT+7',
    locations: ['Bangkok', 'Jakarta', 'Ho Chi Minh City', 'Hanoi']
  },
  {
    gmt: 'GMT+8',
    locations: ['Singapore', 'Kuala Lumpur', 'Beijing', 'Shanghai', 'Hong Kong', 'Taipei', 'Perth', 'Manila']
  },
  {
    gmt: 'GMT+9',
    locations: ['Tokyo', 'Seoul', 'Osaka']
  },
  {
    gmt: 'GMT+10',
    locations: ['Sydney', 'Melbourne', 'Brisbane']
  },
  {
    gmt: 'GMT+11',
    locations: ['Solomon Islands']
  },
  {
    gmt: 'GMT+12',
    locations: ['Auckland', 'Wellington', 'Fiji']
  }
];

// Get timezone offset for a location
export const getLocationTimezone = (locationName) => {
  for (const tz of timezonesByGMT) {
    const location = tz.locations.find(loc => 
      loc.toLowerCase().includes(locationName.toLowerCase()) ||
      locationName.toLowerCase().includes(loc.toLowerCase())
    );
    if (location) {
      return tz.gmt;
    }
  }
  return 'GMT+0';
};

// Get current device timezone
export const getCurrentTimezone = () => {
  const offset = -new Date().getTimezoneOffset() / 60;
  const sign = offset >= 0 ? '+' : '';
  return `GMT${sign}${offset}`;
};
